export enum NotificationTypes {
    TEXT_NOTIFICATION = 'TextNotification',
    IMAGE_APPROVED_NOTIFICATION = 'ImageApprovedNotification',
    IMAGE_REJECTED_NOTIFICATION = 'ImageRejectedNotification',
    ACCOUNT_UPDATED_NOTIFICATION = 'AccountUpdatedNotification',
    BALANCE_UPDATED_NOTIFICATION = 'BalanceUpdatedNotification',
    TEXT_TEMPLATE_NOTIFICATION = 'TextTemplateNotification',
}